<template>
  <div>
    <el-input
      type="textarea"
      :rows="2"
      placeholder=""
      v-model="maintLog.sqls">
    </el-input>
    <br/><br/>
    <el-button type="primary" @click="runLog">submit</el-button>
  </div>
</template>
<script>
import {runMaintLog} from '@/services/maintLog.service';

export default {
  data () {
    return {
      maintLog: {
        sqls: ''
      }
    }
  },
  methods: {
    async runLog () {
      let data = await runMaintLog(this.maintLog);
      if (data.code === 'SUCCESS') {
        this.$message.success('run OK');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MaintLogView.vue